export default __webpack_public_path__ + "app/module/eficiencia-fiscal/view/contrato/modal/regime-tributario-icms/modal.html";